module.exports = __webpack_public_path__ + "img/IMG_8673_L_BlackMatted_MockedUp.83b76be6.jpg";